<script>
  import { datadogRum } from '@datadog/browser-rum';
  import { browser } from '$app/environment';
  import { env } from '$env/dynamic/public';
  import { PreferenceState, analyticsStore } from '$lib/analytics/store';

  function enableRUM() {
    if (!browser) {
      return;
    }

    if (env.PUBLIC_ENVIRONMENT !== 'production') {
      return;
    }

    datadogRum.init({
      applicationId: '4f23a7a4-91a1-4322-9c42-41b559e77615',
      clientToken: 'pub1479a7d87a9b1d8356b4c579f687b89d',
      site: 'datadoghq.com',
      service: 'block-web',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      env: env.PUBLIC_ENVIRONMENT
    });

    datadogRum.startSessionReplayRecording();
  }

  $: if ($analyticsStore.isDisabled === PreferenceState.No) {
    enableRUM();
  }
</script>
